export const downloadExcel = ({ blob, response }: {blob: Blob, response: Response }) => {
  const contentDisposition = response.headers.get('Content-Disposition') || '';
  const fileName = contentDisposition.split('filename=')?.[1]?.split(';')?.[0] || 'unknown';
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = decodeURIComponent(fileName);
  a.click();
};
